import React from "react";

/**
 * HighlightCheckIcon
 *
 * Icon for highlighting a checked/selected feature. Used e.g. for transmission highlight.
 */
const HighlightCheckIcon: React.FC<{ className?: string }> = ({
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <path
      d="M20 6L9 17L4 12"
      stroke="currentColor"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>
);

export default HighlightCheckIcon;
